import React, { useState } from 'react';
import { Upload, Modal } from 'antd';
import cn from 'classnames';
import { UploadChangeParam, UploadFile as UploadFileProps, UploadListType } from 'antd/lib/upload/interface';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

import styles from './styles.module.scss';

type Props = {
    onChange: (file: any) => void;
    defaultValue: any;
    maxCount?: number;
    multiple?: boolean;
    disabled?: boolean;
    listType?: UploadListType;
};

export const UploadFile = ({
    onChange,
    defaultValue,
    disabled,
    maxCount,
    multiple,
    listType = 'picture-card',
}: Props) => {
    const [preview, setPreview] = useState<string | undefined>();
    const [fileList, setFileList] = useState<UploadFileProps[]>(defaultValue.filter((item: any) => item) || []);

    const uploadButton = fileList.length === maxCount || (fileList.length && !multiple) ? null : (
        <div className={ cn({ [styles.button]: listType !== 'picture-card' }) }>
            <PlusOutlined />
            <div>Загрузить</div>
        </div>
    );

    const beforeUpload = () => false;

    const onChangeFile = (info: UploadChangeParam) => {
        const files = info.fileList.map((item) => item.originFileObj || item);

        onChange(multiple ? files : files[0]);
        setFileList(info.fileList);
    };

    const onPreview = (file: UploadFileProps) => {
        const url = file.url || URL.createObjectURL(file.originFileObj);

        setPreview(url);
    };

    return (
        <div>
            <Upload
                fileList={ fileList }
                listType={ listType }
                beforeUpload={ beforeUpload }
                onPreview={ onPreview }
                onChange={ onChangeFile }
                disabled={ disabled }
                multiple={ multiple }
            >
                { uploadButton }
            </Upload>
            <Modal
                open={ Boolean(preview) }
                footer={ null }
                onCancel={ () => setPreview(undefined) }
                bodyStyle={ { padding: 0 } }
                closeIcon={ <CloseOutlined style={ { backgroundColor: '#fff', padding: 20 } } /> }
            >
                <img style={ { width: '100%' } } src={ preview } alt="" />
            </Modal>
        </div>
    );
};
